import React from "react";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";
import { formatDate } from "common/FunctionUtils";
import { YearMonthFilter } from "../holiday-pension-filters/YearMonthFilter";

export const HolidayPayPDFModal = ({
  show,
  t,
  setShow,
  incomeData,
  totalSavings,
  getTransaction,
  getPayoutHistory,
  handleDownloadPDF,
  filteredMonth,
  setFilteredMonth,
  filteredYear,
  setFilteredYear,
  showAllHistory,
  setShowAllHistory,
  showAllHistoryPayout,
  setShowAllHistoryPayout,
  filteredMonthPayout,
  setFilteredMonthPayout,
  filteredYearPayout,
  setFilteredYearPayout
}) => {
  const mainLogoNew = `/assets/fakt-logo.png`;

  const handleChangeDate = (e, type) => {
    setShowAllHistory(false);
    if (type === "month") {
      setFilteredMonth(e.target.value);
    } else {
      setFilteredYear(e.target.value);
    }
  };

  const handleChangeDatePayout = (e, type) => {
    setShowAllHistoryPayout(false);
    if (type === "month") {
      setFilteredMonthPayout(e.target.value);
    } else {
      setFilteredYearPayout(e.target.value);
    }
  };
  const language = localStorage.getItem("i18nextLng");

  return (
    <>
      <Modal
        show={show.PDFModal}
        onHide={() => {
          setShow({ PDFModal: false });
          setFilteredMonth();
          setFilteredYear();
          setShowAllHistory(true);
          setFilteredMonthPayout();
          setFilteredYearPayout();
          setShowAllHistoryPayout(true);
        }}
      >
        <ModalHeader>
          {t("Download PDF")}.
          <AiOutlineClose
            size={25}
            onClick={() => {
              setShow({ PDFModal: false });
              setFilteredMonth();
              setFilteredYear();
              setShowAllHistory(true);
              setFilteredMonthPayout();
              setFilteredYearPayout();
              setShowAllHistoryPayout(true);
            }}
          />
        </ModalHeader>
        <ModalBody id="salary-modal">
          <div>
            <div className="page-content EconomyInvoices my_rpnsvs holiday_pay">
              <div className="invoice-details-part-container flex-column mt-4 w-100">
                <span className="invoice-details-title">
                  <img
                    className={`mr-4 mb-4 logo img-fluid`}
                    src={mainLogoNew}
                    alt="site-logo"
                    loading="lazy"
                  />
                </span>
                <span className="invoice-details-title">
                  {t(`Your holiday pay amount`)}
                </span>
              </div>

              <div className="row mb-3">
                <div className="col">
                  <div className="d-flex align-items-center justify-content-between mt-1 p-2">
                    <div className="first">
                      <div className="inner-group">
                        <div className="customer-data d-flex align-items-center ">
                          <h6 className="m-0 font-weight-bold">
                            {t("User Id")}:&nbsp;
                          </h6>
                          <p className="m-0">
                            {incomeData?.values?.user?.userId}
                          </p>
                        </div>
                        <div className="customer-data d-flex align-items-center">
                          <h6 className="m-0 font-weight-bold">
                            {t("User Name")}:&nbsp;
                          </h6>
                          <p className="m-0">
                            {incomeData?.values?.user?.firstName}{" "}
                            {incomeData?.values?.user?.lastName}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="second">
                      <div className="inner-group">
                        <div className="customer-data d-flex align-items-center">
                          <h6 className="m-0 font-weight-bold">
                            {incomeData?.values?.user?.ssn
                              ? t("SSN No.")
                              : t("DOB")}
                            :&nbsp;
                          </h6>

                          <p className="m-0">
                            {incomeData?.values?.user?.ssn ||
                              incomeData?.values?.user?.dateOfBirth}
                          </p>
                        </div>

                        <div className="customer-data d-flex align-items-center">
                          <h6 className="m-0 font-weight-bold">
                            {t("Email")}:&nbsp;
                          </h6>
                          <p className="m-0">
                            {incomeData?.values?.user?.email}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="border mt-2">
                <Row>
                  <Col
                    className="first_remove p-2 text-center"
                    lg={6}
                    md={6}
                    sm={12}
                  >
                    {t("Total Savings")}
                  </Col>
                  <Col className="p-2 text-center" lg={6} md={6} sm={12}>
                    {t("Balance Left")}
                  </Col>
                </Row>
                <div className="border">
                  <Row>
                    <Col
                      className="first_remove p-2 text-center"
                      lg={6}
                      md={6}
                      sm={12}
                    >
                      <p>{Number(totalSavings)?.toFixed(2)} SEK</p>
                    </Col>
                    <Col className="p-2 text-center" lg={6} md={6} sm={12}>
                      <p>{incomeData.values?.holidaySavingsAmount || 0} SEK</p>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center mt-3">
                <h4 className="text-dark ">{t("Transaction History")}</h4>
                <YearMonthFilter
                  t={t}
                  showAllHistory={showAllHistory}
                  setShowAllHistory={setShowAllHistory}
                  filteredMonth={filteredMonth}
                  filteredYear={filteredYear}
                  handleChangeDate={handleChangeDate}
                  setFilteredMonth={setFilteredMonth}
                  setFilteredYear={setFilteredYear}
                />
              </div>
              
              <div className="w-100 table-div">
                <Table striped bordered>
                  <thead>
                    <tr>
                      <th>{t("Id")}</th>
                      <th>{t("Invoice No")}</th>
                      <th>{t("Amount")}</th>
                      <th>{t("Created Date")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getTransaction?.length ? (
                      getTransaction?.map((item) => (
                        <tr key={item?.invoiceNumber}>
                          <td>{item?.userId}</td>
                          <td>{item?.invoiceNumber}</td>

                          <td>{item?.holidaySavingsAmount} SEK</td>
                          <td>{formatDate(item?.createdDate, false, language)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4">
                          <h6>{t("No data found")}</h6>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>

            
              <div className="d-flex justify-content-between align-items-center mt-3">
              <h4 className="text-dark mt-3">{t("Payout History")}</h4>
                <YearMonthFilter
                  t={t}
                  showAllHistory={showAllHistoryPayout}
                  setShowAllHistory={setShowAllHistoryPayout}
                  filteredMonth={filteredMonthPayout}
                  filteredYear={filteredYearPayout}
                  handleChangeDate={handleChangeDatePayout}
                  setFilteredMonth={setFilteredMonthPayout}
                  setFilteredYear={setFilteredYearPayout}
                />
              </div>
              <div className="w-100  table-div">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th className="invoice_tabeletext">{t("Id")}</th>
                      <th className="invoice_tabeletext">
                        {t("Total amount requested")}
                      </th>
                      <th className="invoice_tabeletext">
                        {t("Administrator Fee")}
                      </th>
                      <th className="invoice_tabeletext">{t("Amount")}</th>
                      <th className="invoice_tabeletext">{t("Tax Amount")}</th>
                      <th className="invoice_tabeletext">
                        {t("To Pay Amount")}
                      </th>
                      <th className="invoice_tabeletext">{t("Status")}</th>
                      <th className="invoice_tabeletext">{t("Payout Date")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getPayoutHistory?.length ? (
                      getPayoutHistory
                        ?.filter((d) => d?.status === 2)
                        ?.map((tranData) => (
                          <tr key={tranData?.id}>
                            <td>{tranData?.id}</td>
                            <td>{tranData?.totalAmountRequested}</td>
                            <td>{tranData?.administratorFee || 0}</td>
                            <td>{tranData?.amount || 0}</td>
                            <td>{tranData?.taxAmount || 0}</td>
                            <td>{tranData?.toPayAmount || 0}</td>
                            <td>
                              {tranData?.status === 1
                                ? t("Unpaid")
                                : t("Paid")}
                            </td>
                            <td>
                              {tranData?.status === 2 &&
                                formatDate(tranData?.paidDate || "----", false, language)}
                            </td>
                          </tr>
                        ))
                    ) : (
                      <tr>
                        <td colSpan="8">
                          <h6>{t("No data found")}</h6>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="repsv_in">
          <button
            className="outline_btn_new cancel_pension"
            onClick={() => {
              setShow({ PDFModal: false });
              setFilteredMonth();
              setFilteredYear();
              setShowAllHistory(true);
              setFilteredMonthPayout();
              setFilteredYearPayout();
              setShowAllHistoryPayout(true);
            }}
          >
            {t("Cancel")}
          </button>
          <Button
            className="outlines-primary cancel_pension"
            onClick={() => handleDownloadPDF()}
          >
            {t("Download")}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
